var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.w != null ? _vm._t("default", null, {
    "width": _vm.w
  }) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }